export const ActivityAuthorTypeEnum = {
  /**
   * `authorId` is an ApiKey
   */
  api: 'api',
  /**
   * `authorId` is an User
   */
  user: 'user',
  /**
   * `authorId` is null
   */
  system: 'system',
  /**
   * `authorId` is a Template
   * @TODO - E-5467 - Migrate old activity type / author type
   * @deprecated
   */
  template: 'template',
  /**
   * `authorId` is an Individual
   */
  contact: 'contact',
  /**
   * `authorId` is null
   * @TODO - E-5467 - Migrate old activity type / author type
   * @deprecated
   */
  workflow: 'workflow',
} as const;
export type ActivityAuthorTypeEnum =
  (typeof ActivityAuthorTypeEnum)[keyof typeof ActivityAuthorTypeEnum];
